export var DirectoryScopeKind;
(function (DirectoryScopeKind) {
    DirectoryScopeKind["DIRECTORY_SCOPE_KIND_TENANT"] = "DIRECTORY_SCOPE_KIND_TENANT";
    DirectoryScopeKind["DIRECTORY_SCOPE_KIND_ADMINISTRATIVE_UNIT"] = "DIRECTORY_SCOPE_KIND_ADMINISTRATIVE_UNIT";
    DirectoryScopeKind["DIRECTORY_SCOPE_KIND_DIRECTORY_OBJECT"] = "DIRECTORY_SCOPE_KIND_DIRECTORY_OBJECT";
})(DirectoryScopeKind || (DirectoryScopeKind = {}));
